import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Document\Editor\UpdateDocumentEditorController::__invoke
* @see app/Http/Controllers/Document/Editor/UpdateDocumentEditorController.php
* @route '/api/editor/{type}/{document}'
*/
const UpdateDocumentEditorController = (args: { type: string | number, document: string | number } | [type: string | number, document: string | number ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDocumentEditorController.url(args, options),
    method: 'put',
})

UpdateDocumentEditorController.definition = {
    methods: ["put"],
    url: '/api/editor/{type}/{document}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Document\Editor\UpdateDocumentEditorController::__invoke
* @see app/Http/Controllers/Document/Editor/UpdateDocumentEditorController.php
* @route '/api/editor/{type}/{document}'
*/
UpdateDocumentEditorController.url = (args: { type: string | number, document: string | number } | [type: string | number, document: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            type: args[0],
            document: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        type: args.type,
        document: args.document,
    }

    return UpdateDocumentEditorController.definition.url
            .replace('{type}', parsedArgs.type.toString())
            .replace('{document}', parsedArgs.document.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Document\Editor\UpdateDocumentEditorController::__invoke
* @see app/Http/Controllers/Document/Editor/UpdateDocumentEditorController.php
* @route '/api/editor/{type}/{document}'
*/
UpdateDocumentEditorController.put = (args: { type: string | number, document: string | number } | [type: string | number, document: string | number ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDocumentEditorController.url(args, options),
    method: 'put',
})

export default UpdateDocumentEditorController